<!--
	@name app-dialog-privacy
	@description Privacy Notice
	@date 2020/06/03
	@license no license
	@copywrite {{ site.company.name }}
-->

<template>
	<common-dialog ref="dialog" :component="$options.name">
		<template #header>
			Privacy Notice
		</template>
		<template v-if="site" #body>
			<app-common-privacy />
		</template>
	</common-dialog>
</template>

<script>
	import CommonDialog from '@/component/common/dialog';
	import AppCommonPrivacy from '@/component/app/common/privacy';
	import { mapState } from 'vuex';

	export default {
		name: 'app-dialog-privacy',

		components: { CommonDialog, AppCommonPrivacy },

		data: () => ({
			website_name: `www.${window.location.hostname}`
		}),

		computed: { ...mapState('CmsSite', ['site']) },

		watch: {},

		methods: {
			/**
			 * @name open
			 * @description Open dialog and set properties
			 */
			open() {
				this.$refs.dialog.open();
			}
		}
	};
</script>

<style lang="scss" scoped></style>
